import { render } from "./AssistantBanner.vue?vue&type=template&id=7385d82c&scoped=true"
import script from "./AssistantBanner.vue?vue&type=script&lang=js"
export * from "./AssistantBanner.vue?vue&type=script&lang=js"

import "./AssistantBanner.vue?vue&type=style&index=0&id=7385d82c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7385d82c"]])

export default __exports__